<template>
  <div class="history-voucher">
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a class="nav-link left" href="#timeline">{{ $t('voucherHistory.timeline') }}</a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link active right"
          href="#table"
          role="tab"
          data-toggle="tab"
          >{{ $t('voucherHistory.table') }}</a
        >
      </li>
    </ul>
    <div class="tab-content">
      <!-- <div role="tabpanel" class="tab-pane fade" id="timeline">
        <div class="history-voucher-content">
          <div id="app" class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="swiper-container">
                  <div class="swiper-wrapper timeline">
                    <div class="swiper-slide" v-for="(item, index) in dataVoucherHistoryList" :key="item + index">
                      <div class="timestamp">
                        <span class="date">{{item.dateCreated}}</span>
                      </div>
                      <div class="status">
                        <span></span>
                        <div class="title">
                          {{voucherSerial}}
                        </div>
                        <p v-if="item.fromEntity"><span style="font-weight:600;">Từ</span> {{item.fromEntity}} <span style="font-weight:600;">đến</span> {{item.toEntity}}</p>
                        <p>{{item.description}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div
        role="tabpanel"
        class="tab-pane fade active show"
        id="table"
        style="width:100%;"
      >
        <div class="table-content-body">
          <div class="title-table">
            <h4>{{ $t("voucherHistory.tableHistory.transactionHistory") }}</h4>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th
                  scope="col"
                  v-for="(header, index) in voucherHistoryHeaders"
                  :key="header.value + index"
                >
                  {{ $t(header.text) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(voucherHistory, index) in voucherHistoryList"
                :key="voucherHistory + index"
              >
                <td scope="row">{{ voucherHistory.stt }}</td>
                <td>{{ voucherHistory.dateCreated }}</td>
                <td>
                  <div
                    v-for="(voucherSerial,
                    index) in voucherHistory.voucherSerial"
                    :key="voucherSerial + index"
                  >
                    <span>{{ voucherSerial }}</span>
                  </div>
                </td>
                <td>{{ voucherHistory.fromEntity }}</td>
                <!-- <td>{{ voucherHistory.toEntity }}</td> -->
                <td>{{ voucherHistory.fromUser }}</td>
                <!-- <td>{{ voucherHistory.toUser }}</td> -->
                <!-- <td>{{ voucherHistory.user }}</td> -->
                <!-- <td>{{ $t(getHistoryActionName(voucherHistory.action)) }}</td> -->
                <td>{{ voucherHistory.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import dateUtils from "Utils/dateUtils";
import functionUtils from "Utils/functionUtils";
import VoucherHistoryType from "Enum/voucherHistoryType";
import LoginFromType from 'Enum/loginFromType'

export default {
  data: () => ({
    voucherSerial: null,
    voucherHistoryList: [],
    paginate: {
      totalPage: 1,
      currentPage: 1,
      rowPerPage: 1,
    },
    voucherHistoryHeaders: [
      { text: "common.nonumber", value: "stt" },
      { text: "voucherHistory.dateAction", value: "dateCreated" },
      { text: "voucherHistory.tableHistory.voucherSerial", value: "voucherSerial" },
      { text: "voucherHistory.implementAgencies", value: "fromEntity" },
      // { text: "voucherHistory.receivingAgencies", value: "toEntity" },
      { text: "voucherHistory.customerAction", value: "fromUser" },
      // { text: "voucherHistory.receivingCustomer", value: "toUser" },
      // { text: "voucherHistory.peopleAction", value: "user" },
      // { text: "voucherHistory.action", value: "action" },
      { text: "voucherHistory.tableHistory.description", value: "description" },
    ],
    dataVoucherHistoryList: []
  }),
  computed: {
    ...mapGetters(["VOUCHER_HISTORY_DATA"]),
  },
  watch: {
    VOUCHER_HISTORY_DATA() {
      let res = this.VOUCHER_HISTORY_DATA
      // Handle paginate
      this.paginate.currentPage = res.paginate.currentPage;
      this.paginate.totalPage = res.paginate.totalPage;
      this.paginate.rowPerPage = res.paginate.perPage / 2;
      // Handle data
      let data = res.results;
      this.voucherHistoryList = [];
      for (let i = 0, size = data.length; i < size; i++) {
        let voucherSerialCodeList = [];
        let description = this.parseVoucherHistoryDescription(
          data[i].type,
          data[i].from_entity, data[i].to_entity,
          data[i].from_user, data[i].to_user,
          data[i].voucher_list.length,
          data[i].product_order, data[i].store_channel_data
        )
        for (let j = 0, voucherSize = data[i].voucher_list.length >= 5 ? 5 : data[i].voucher_list.length; j < voucherSize; j++) {
          voucherSerialCodeList.push(data[i].voucher_list[j].serial);
        }
        let voucherHistoryObj = {
          stt: i + 1 + (res.paginate.currentPage - 1) * res.paginate.pageSize,
          id: data[i].id,
          fromEntity: data[i].from_entity.name,
          toEntity: data[i].to_entity.name,
          user: functionUtils.concatFullname(data[i].user_created.last_name, data[i].user_created.first_name),
          description: description,
          dateCreated: dateUtils.formatDate(
            data[i].date_created,
            dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
            dateUtils.STATIC_FORMAT_TIME_DATE
          ),
          voucherSerial: voucherSerialCodeList,
          fromUser: data[i].from_user.last_name
            ? functionUtils.concatFullname(data[i].from_user.last_name, data[i].from_user.first_name)
            : data[i].from_user.email,
          toUser: data[i].to_user.last_name
            ? functionUtils.concatFullname(data[i].to_user.last_name, data[i].to_user.first_name)
            : data[i].to_user.email,
          action: data[i].type,
        };
        this.voucherHistoryList.push(voucherHistoryObj);
      }
      this.isLoading = false;
    },
  },
  created() {
    this.getVoucherHistoryList();
    let length = sessionStorage.getItem("voucherLength");
    if (length != 0) {
      for (let i = 0, size = length; i < size; i++) {
        let voucher = {};
        this.dataVoucherHistoryList.push(voucher);
      }
    }
  },
  methods: {
    getHistoryActionName: function (type) {
      if (type === VoucherHistoryType.CREATE) {
        return 'voucherHistory.type.create'
      } else if (type === VoucherHistoryType.DISTRIBUTE) {
        return 'voucherHistory.type.distribute'
      } else if (type === VoucherHistoryType.ASSIGNED) {
        return 'voucherHistory.type.assigned'
      } else if (type === VoucherHistoryType.USED) {
        return 'voucherHistory.type.used'
      } else if (type === VoucherHistoryType.SEND_CONFIRM_USED_REQUEST) {
        return 'voucherHistory.type.sendConfirmUsedRequest'
      } else if (type === VoucherHistoryType.CUSTOMER_CONFIRM_USED) {
        return 'voucherHistory.type.customerConfirmUsed'
      } else if (type === VoucherHistoryType.CUSTOMER_CANCEL_USED) {
        return 'voucherHistory.type.customerCancelUsed'
      } else if (type === VoucherHistoryType.CUSTOMER_RETURN_VOUCHER) {
        return 'voucherHistory.type.customerReturnUsed'
      } else if (type === VoucherHistoryType.CUSTOMER_ASSIGNED_VOUCHER_TO_CUSTOMER) {
        return 'voucherHistory.type.customerDeliveryVoucher'
      } else if (type === VoucherHistoryType.DELETED) {
        return 'voucherHistory.type.deleted'
      } else if (type === VoucherHistoryType.USED_FROM_THIRD_PARTIES) {
        return 'voucherHistory.type.usedFromThirdParties'
      } else if (type === VoucherHistoryType.PROMOTION_USED) {
        return 'voucherHistory.type.usePromotionVoucher'
      } else if (type === VoucherHistoryType.CREATE_PROMOTION_VOUCHER) {
        return 'voucherHistory.type.createPromotionVoucher'
      } else if (type === VoucherHistoryType.RECONCILIATION_APPROVED) {
        return 'voucherHistory.type.approveReconciliation'
      } else if (type === VoucherHistoryType.RECONCILIATION_REJECTED) {
        return 'voucherHistory.type.cancelReconciliation'
      } else if (type === VoucherHistoryType.LOCKED_USING) {
        return 'voucherHistory.type.lockedVoucher'
      } else if (type === VoucherHistoryType.CONFIRMED_USE_LOCKED) {
        return 'voucherHistory.type.confirmUseLockedVoucher'
      } else if (type === VoucherHistoryType.REFUND) {
        return 'voucherHistory.type.refundVoucher'
      } else if (type === VoucherHistoryType.ADMIN_SYSTEM_DELIVERY_VOUCHER_OTHER_CUSTOMER) {
        return 'voucherHistory.type.adminSystemDeliveryVoucher'
      } else if (type === VoucherHistoryType.DISABLE_VOUCHER) {
        return 'voucherHistory.type.disableVoucher'
      } else if (type === VoucherHistoryType.ENABLE_VOUCHER) {
        return 'voucherHistory.type.enableVoucher'
      } else if (type === VoucherHistoryType.RESERVED_ORDER) {
        return 'voucherHistory.type.orderVoucher'
      } else if (type === VoucherHistoryType.ACCOUNTANT_CANCEL_ORDER) {
        return 'voucherHistory.type.cancelOrderVoucher'
      } else if (type === VoucherHistoryType.ACCOUNTANT_CONFIRM_ORDER) {
        return 'voucherHistory.type.confirmOrderVoucher'
      } else if (type === VoucherHistoryType.PUBLISHED_ONTO_STORE_CHANNEL) {
        return 'voucherHistory.type.publishedStoreChannel'
      } else if (type === VoucherHistoryType.TAKE_BACK_FROM_STORE_CHANNEL) {
        return 'voucherHistory.type.takebackStoreChannel'
      } else if (type === VoucherHistoryType.PURCHASE_PAYMENT_STORE_CHANNEL) {
        return 'voucherHistory.type.purchaseOrder'
      } else if (type === VoucherHistoryType.CANCEL_PAYMENT_STORE_CHANNEL) {
        return 'voucherHistory.type.cancelOrder'
      } else if (type === VoucherHistoryType.EXTEND_EXPIRATION) {
        return 'voucherHistory.type.extendExpiration'
      }
      return ''
    },
    parseVoucherHistoryDescription: function (type, fromEntity, toEntity, fromUser, toUser, totalVoucher, productOrder, storeChannel) {
      let description = this.$t('voucherHistory.description.undefined')
      if (type === VoucherHistoryType.CREATE) {
        description = this.$t('voucherHistory.description.create', { entity: fromEntity.name, amount: totalVoucher })
      } else if (type === VoucherHistoryType.DISTRIBUTE) {
        description = this.$t('voucherHistory.description.distribute', { entity: fromEntity.name, amount: totalVoucher, toEntity: toEntity.name })
      } else if (type === VoucherHistoryType.ASSIGNED) {
        description = this.$t('voucherHistory.description.assigned', { entity: fromEntity.name, amount: totalVoucher, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.USED) {
        description = this.$t('voucherHistory.description.used', { entity: fromEntity.name, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.SEND_CONFIRM_USED_REQUEST) {
        description = this.$t('voucherHistory.description.sendConfirmUsedRequest', { entity: fromEntity.name, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.CUSTOMER_CONFIRM_USED) {
        description = this.$t('voucherHistory.description.customerConfirmUsed', { customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email), entity: fromEntity.name })
      } else if (type === VoucherHistoryType.CUSTOMER_CANCEL_USED) {
        // description = this.$t('voucherHistory.description.customerCancelUsed')
      } else if (type === VoucherHistoryType.CUSTOMER_RETURN_VOUCHER) {
        // description = this.$t('voucherHistory.description.customerReturnUsed')
      } else if (type === VoucherHistoryType.DELETED) {
        description = this.$t('voucherHistory.description.deleted', { entity: fromEntity.name })
      } else if (type === VoucherHistoryType.USED_FROM_THIRD_PARTIES) {
        description = this.$t('voucherHistory.description.usedFromThirdParties', { entity: fromEntity.name, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.CUSTOMER_ASSIGNED_VOUCHER_TO_CUSTOMER) {
        description = this.$t('voucherHistory.description.customerDeliveryVoucher', { owner: functionUtils.concatFullname(fromUser.last_name, fromUser.first_name, fromUser.email), customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.PROMOTION_USED) {
        description = this.$t('voucherHistory.description.usePromotionVoucher', { entity: fromEntity.name, customer: functionUtils.concatFullname(fromUser.last_name, fromUser.first_name, fromUser.email) })
      } else if (type === VoucherHistoryType.CREATE_PROMOTION_VOUCHER) {
        description = this.$t('voucherHistory.description.createPromotionVoucher', { entity: fromEntity.name })
      } else if (type === VoucherHistoryType.RECONCILIATION_APPROVED) {
        description = this.$t('voucherHistory.description.approveReconciliation', { entity: fromEntity.name, requestEntity: toEntity.name })
      } else if (type === VoucherHistoryType.RECONCILIATION_REJECTED) {
        description = this.$t('voucherHistory.description.cancelReconciliation', { entity: fromEntity.name, requestEntity: toEntity.name })
      } else if (type === VoucherHistoryType.LOCKED_USING) {
        description = this.$t('voucherHistory.description.lockedVoucher', { entity: fromEntity.name, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.CONFIRMED_USE_LOCKED) {
        description = this.$t('voucherHistory.description.confirmUseLockedVoucher', { entity: fromEntity.name })
      } else if (type === VoucherHistoryType.REFUND) {
        description = this.$t('voucherHistory.description.refundVoucher', { entity: fromEntity.name })
      } else if (type === VoucherHistoryType.ADMIN_SYSTEM_DELIVERY_VOUCHER_OTHER_CUSTOMER) {
        description = this.$t('voucherHistory.description.adminSystemDeliveryVoucher', { customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.DISABLE_VOUCHER) {
        description = this.$t('voucherHistory.description.disableVoucher', { entity: fromEntity.name, customer: functionUtils.concatFullname(toUser.last_name, toUser.first_name, toUser.email) })
      } else if (type === VoucherHistoryType.ENABLE_VOUCHER) {
        description = this.$t('voucherHistory.description.enableVoucher', { entity: fromEntity.name })
      } else if (type === VoucherHistoryType.RESERVED_ORDER) {
        description = this.$t('voucherHistory.description.orderVoucher', { storeChannel: storeChannel.name, code: productOrder.code })
      } else if (type === VoucherHistoryType.ACCOUNTANT_CANCEL_ORDER) {
        description = this.$t('voucherHistory.description.cancelOrderVoucher', { code: productOrder.code, storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.ACCOUNTANT_CONFIRM_ORDER) {
        description = this.$t('voucherHistory.description.confirmOrderVoucher', { code: productOrder.code, storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.PUBLISHED_ONTO_STORE_CHANNEL) {
        description = this.$t('voucherHistory.description.publishedStoreChannel', { storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.TAKE_BACK_FROM_STORE_CHANNEL) {
        description = this.$t('voucherHistory.description.takebackStoreChannel', { storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.PURCHASE_PAYMENT_STORE_CHANNEL) {
        description = this.$t('voucherHistory.description.purchaseOrder', { code: productOrder.code, storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.CANCEL_PAYMENT_STORE_CHANNEL) {
        description = this.$t('voucherHistory.description.cancelOrder', { code: productOrder.code, storeChannel: storeChannel.name })
      } else if (type === VoucherHistoryType.EXTEND_EXPIRATION) {
        description = this.$t('voucherHistory.description.extendExpiration')
      }
      return description
    },
    /**
     * Get voucher history list
     */
    getVoucherHistoryList: function() {
      let voucherId = this.$route.params.id;
      let filter = {
        params: {
          page: this.paginate.currentPage,
          voucherId: voucherId,
          loginFromType: LoginFromType.CUSTOMER
        },
      };
      this.isLoading = true;
      this.GET_VOUCHER_HISTORY_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onPageChange: function(page) {
      this.paginate.currentPage = page;
      this.getVoucherHistoryList();
    },
    ...mapActions(["GET_VOUCHER_HISTORY_LIST"]),
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      pagination: ".swiper-pagination",
      slidesPerView: 3,
      grabCursor: true,
      paginationClickable: true,
      nextButton: ".next-slide",
      prevButton: ".prev-slide",
    });
    sessionStorage.setItem("Swiper", swiper);
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";

.history-voucher {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  flex-direction: column;
  padding-top: 5rem;

  ul {
    width: 90%;
    display: flex;
    justify-content: center;
    border: none;
    border: 1px solid #3cb371;
    border-radius: 10px;
    margin: 0 auto;
    .nav-item {
      width: 50%;
      .nav-link {
        border: none;
        color: #3cb371;
        text-align: center;

        &.active {
          color: #fff;
          background-color: #3cb371;
          margin: 0;
        }

        &.left {
          border-radius: 9px 0 0 9px;
        }

        &.right {
          border-radius: 0 9px 9px 0;
        }
      }

      &.start {
        border: none;
      }
    }
  }

  .tab-content {
    display: flex;
    justify-content: center;

    .history-voucher-content {
      body {
        background: #e8eeff;
      }

      #app {
        padding: 50px 0;
      }

      .timeline {
        margin: 50px 0;
        list-style-type: none;
        display: flex;
        padding: 0;
        text-align: center;
      }

      .timeline li {
        transition: all 200ms ease-in;
      }

      .timestamp {
        width: 200px;
        margin-bottom: 20px;
        padding: 0px 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-weight: 100;
      }

      .status {
        padding: 0px 40px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        border-top: 4px solid $second;
        position: relative;
        transition: all 200ms ease-in;

        span {
          font-weight: 600;
          padding-top: 20px;
        }

        .title {
          margin-top: 1rem;
          font-size: 30px;
          font-weight: 600;
        }
      }

      .status span:before {
        content: "";
        width: 25px;
        height: 25px;
        background-color: #e8eeff;
        border-radius: 25px;
        border: 4px solid $second;
        position: absolute;
        top: -15px;
        left: 42%;
        transition: all 200ms ease-in;
      }

      .swiper-control {
        text-align: right;
      }

      .swiper-container {
        width: 100%;
        height: 100%;
        margin: 50px 0;
        overflow: hidden;
        padding: 0 20px 30px 20px;
      }

      .swiper-slide {
        width: 300px;
        text-align: center;
        font-size: 18px;
      }

      .swiper-slide:nth-child(2n) {
        width: 30%;
      }

      .swiper-slide:nth-child(3n) {
        width: 30%;
      }
    }

    .table-content-body {
      margin-top: 5rem;

      .title-table {
        h4 {
          margin: 0;
          padding: 20px;
          background: $second;
          color: #fff;
        }
      }
    }
  }
}
</style>
